<script setup lang="ts">
import HeaderBreadcrumbs from '@/components/layouts/header/HeaderBreadcrumbs.vue'
import HeaderLogo from '@/components/layouts/header/HeaderLogo.vue'
import HeaderUser from '@/components/layouts/header/HeaderUser.vue'
</script>

<template>
  <header
    class="bg-background flex h-16 w-full items-center justify-start gap-x-5 border-b px-10 shadow-sm"
  >
    <HeaderLogo />
    <HeaderBreadcrumbs />
    <HeaderUser class="ml-auto" />
  </header>
</template>
